import axios from 'axios'

const API_PATH = 'api/v2/admins/products'

const ProductHistoriesApiV2 = {
  /**
   * Get histories by given product id
   * @param {number} productId Product ID
   */
  get: async (productId) => {
    const path     = `${API_PATH}/${productId}/histories`
    const response = axios.get(path)
    return response
  }
}

export default ProductHistoriesApiV2
